// extracted by mini-css-extract-plugin
export default {"flexGroup":"style_flexGroup__bPS8t"};